'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Functions$BsBastet = require("bs-bastet/bastet/src/Functions.bs.js");

function ApplicativeExtensions(A) {
  var BsApplicativeExtensions = Functions$BsBastet.Applicative(A);
  var all = function (param) {
    if (param) {
      return Curry._2(A.apply, Curry._2(A.map, (function (result, rest) {
                        return {
                                hd: result,
                                tl: rest
                              };
                      }), param.hd), all(param.tl));
    } else {
      return Curry._1(A.pure, /* [] */0);
    }
  };
  return {
          BsApplicativeExtensions: BsApplicativeExtensions,
          liftA1: BsApplicativeExtensions.liftA1,
          when_: BsApplicativeExtensions.when_,
          unless: BsApplicativeExtensions.unless,
          all: all
        };
}

exports.ApplicativeExtensions = ApplicativeExtensions;
/* Functions-BsBastet Not a pure module */
